import { cn } from "@/lib/utils";

/** Sidebar / inbox nav row — pair with `navRowClasses()` or `<NavRow>`. */
export const NAV_ROW_BASE =
  "flex w-full min-w-0 items-center gap-2 rounded-md px-2 py-1.5 text-[14px] leading-5 transition-colors hover:bg-foreground/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring";

export function navRowClasses(
  isSelected?: boolean,
  className?: string,
): string {
  return cn(
    NAV_ROW_BASE,
    "cursor-pointer text-left",
    isSelected && "bg-foreground/[0.07]",
    className,
  );
}

/** Outer shell for inbox list rows (DM, mention, catch-up). */
export const INBOX_ROW_SHELL =
  "group rounded-lg border-l-2 border-l-foreground/15 transition-colors duration-[var(--duration-normal)] hover:bg-muted/20";

/** Clickable body inside an inbox row. */
export const inboxRowBodyClasses = (className?: string) =>
  cn("flex cursor-pointer items-start gap-3 px-3 py-3", className);
